(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["livpack-manual-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lp-manual-video')) {
  customElements.define('lp-manual-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const cover = this.querySelector('.lp-manual-video__cover');
      if (!cover) return;
      cover.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (this.querySelector('iframe')) return;
        const frame = document.createElement('iframe');
        frame.src = this.dataset.videoUrl;
        frame.title = this.dataset.videoTitle;
        frame.width = '1920';
        frame.height = '1080';
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        frame.allowFullscreen = true;
        this.replaceChildren(frame);
        frame.focus();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
